'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, TextPassage } from '@petsmart-ui/sparky';
import type { ItemUI } from '@libs/common-node';
import { useOptimizelyFreeShipThreshold } from '../../hooks/useOptimizelyFreeShipThreshold';
import './OptimizelyShipMeter.scss';
type OptimizelyShipMeterProps = {
  autoshipFrequency: number;
  autoshipFrequencyUnitOfMeasure: number;
  previewItem?: Pick<ItemUI, 'id' | 'listPrice' | 'quantity'>;
};
export const OptimizelyShipMeter = t0 => {
  const $ = _c(6);
  const {
    autoshipFrequency,
    autoshipFrequencyUnitOfMeasure,
    previewItem
  } = t0;
  let t1;
  if ($[0] !== autoshipFrequency || $[1] !== autoshipFrequencyUnitOfMeasure || $[2] !== previewItem) {
    t1 = {
      autoshipFrequency,
      autoshipFrequencyUnitOfMeasure,
      previewItem
    };
    $[0] = autoshipFrequency;
    $[1] = autoshipFrequencyUnitOfMeasure;
    $[2] = previewItem;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const shipThreshold = useOptimizelyFreeShipThreshold(t1);
  let t2;
  if ($[4] !== shipThreshold) {
    t2 = Number.parseFloat(shipThreshold) > 0 ? <div className="optimizely-free-ship-meter"><Icon name="box-outline" className="optimizely-free-ship-meter__icon" /><TextPassage className="optimizely-free-ship-meter__text" data-test-id="optex_pop_sla"><span className="optimizely-free-ship-meter__text-threshold">${shipThreshold}</span> away from FREE shipping on your future Autoship orders</TextPassage></div> : <div className="optimizely-free-ship-meter"><Icon name="box-outline" className="optimizely-free-ship-meter__icon" /><TextPassage className="optimizely-free-ship-meter__text" data-test-id="optex_pop_sla">You’re getting FREE shipping on your future Autoship orders!</TextPassage></div>;
    $[4] = shipThreshold;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};